import { Color } from 'lib/Chip';

const ASSET_STATUS = {
  MOUNTED: 'MOUNTED',
  DISMOUNTED: 'DISMOUNTED',
};

export const ASSET_STATUS_BADGE = [
  {
    code: ASSET_STATUS.MOUNTED,
    name: 'Mounted',
    initials: 'M',
    color: Color.GREEN,
  },
  {
    code: ASSET_STATUS.DISMOUNTED,
    name: 'Dismounted',
    initials: 'D',
    color: Color.YELLOW,
  },
];

export default ASSET_STATUS;
